<template>
    <div class="user-edit">
        <h2 class="page-title">Behaviour - <span class="fw-semi-bold">Detail</span></h2>
        <Widget :title="(isNew ? 'New' : 'Edit') + ' behaviour'">
            <Loader v-if="!isNew && isReceiving" :size="40"></Loader>
            <Form v-else>
                <div class="form-group row">
                    <label class="col-md-2" for="title">Title</label>
                    <div class="col-md-5">
                        <input class="form-control" id="title" type="text" :value="behaviour.title"
                               @change="updateBehaviourProperty($event, 'title')"/>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-md-2" for="description">Description</label>
                    <div class="col-md-5">
                        <textarea class="form-control" id="description" type="text" :value="behaviour.description"
                                  @change="updateBehaviourProperty($event, 'description')"/>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-md-2" for="maxStars">Available stars per day</label>
                    <div class="col-md-5">
                        <input class="form-control" id="maxStars" type="number" :value="behaviour.maxNoOfStars"
                               @change="updateBehaviourProperty($event, 'maxNoOfStars')"/>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-md-2" for="maxComments">Available comments per day</label>
                    <div class="col-md-5">
                        <input class="form-control" id="maxComments" type="number" :value="behaviour.maxNoOfComments"
                               @change="updateBehaviourProperty($event, 'maxNoOfComments')"/>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-md-2" for="behaviourDateRange">Date range</label>
                    <v-date-picker
                        class="col-md-5"
                        mode='range'
                        id="behaviourDateRange"
                        v-model='calendarData'
                    />
                </div>
                <div class="form-group row" v-if="global == true">
                    <label class="col-md-2" for="timezone">Timezone</label>
                    <div class="col-md-5">
                        <v-select
                            id="timezone"
                            v-model="behaviour.timezone"
                            :options="getTimezoneOptions()"
                        />
                    </div>
                </div>
                <div class="form-group row" v-if="global == false">
                    <label class="col-md-2" for="timezone">Group</label>
                    <div class="col-md-5">
                        <v-select
                            id="group"
                            v-model="selectedGroup"
                            label="name"
                            :options="groups"
                        />
                    </div>
                </div>
                <div class="abc-checkbox abc-checkbox-primary mb-4">
                    <input type="checkbox"
                           id="isPublic"
                           :checked="behaviour.public == true"
                           @change="togglePublic()"
                    />
                    <label for="isPublic">Active</label>
                </div>
                <div class="abc-checkbox abc-checkbox-primary mb-4">
                    <input type="checkbox"
                           id="isGlobal"
                           :checked="behaviour.global == true"
                           :disabled="!showGlobalOption()"
                           @change="toggleGlobal()"
                    />
                    <label for="isGlobal">Global</label>
                </div>
                <b-alert class="alert-sm w-25" variant="danger" :show="errorsList.length > 0" :key="error"
                         v-for="error in errorsList">
                    {{error}}
                </b-alert>
                <div v-if="isOverlaping && errorsList.length == 0">
                    There is another behaviour configured in the chosen time interval. Are you sure you want to add
                    another one?
                    <b-button variant="success"
                              @click="saveOverlapingBehaviour()">
                        <Loader v-if="isUpdating"></Loader>
                        <span v-else>Yes</span>
                    </b-button>
                    <b-button variant="success"
                              @click="() => {isOverlaping = false}">
                        <Loader v-if="isUpdating"></Loader>
                        <span v-else>No</span>
                    </b-button>
                </div>
                <b-button-toolbar v-else>
                    <b-button variant="success"
                              @click="saveBehaviour()">
                        <Loader v-if="isUpdating"></Loader>
                        <span v-else>Save</span>
                    </b-button>

                    <b-button variant="default" @click="goBack()">
                        Back
                    </b-button>
                </b-button-toolbar>
            </Form>
        </Widget>
    </div>
</template>

<script>
    import {mapActions, mapState} from 'vuex';
    import DatePicker from 'vue2-datepicker';
    import Vue from "vue";
    import moment from 'moment-timezone';
    import Loader from '../../components/Loader/Loader';
    import {firestore} from "../../main";
    import vSelect from "vue-select";

    export default {
        name: "AddBehaviour",
        components: {DatePicker, Loader, vSelect},
        data() {
            return {
                user: JSON.parse(localStorage.getItem('user') || {}),
                popover: false,
                startDate: {},
                endDate: null,
                selectedGroup: null,
                // behaviour: {},
                errorsList: [],
                calendarData: {},
                isOverlaping: false,
                global: false,
            }
        },
        async mounted() {
            await  this.loadBehaviour();

            // if(!this.isNew){
            //   this.behaviour = this.findBehaviour(this.getId())
            // }
        },
        watch: {
            selectedCountry: function (val) {
            },
        },
        computed: {
            ...mapState("behaviours", ["behaviours", "isReceiving", "isUpdating", "isDeleting"]),
            ...mapState("countries", ["selectedCountry"]),
            ...mapState("groups", ["groups"]),
            ...mapState("auth", ["currentUser"]),
            isNew() {
                return this.getId() === -1
            },
            behaviour() {
                return this.findBehaviour(this.getId()) || {}
            }
        },

        methods: {
            ...mapActions("auth", ["fetchCurrentUser","getCurrentUser"]),
            ...mapActions("behaviours", ["createBehaviourRequest", "updateBehaviourRequest", "getBehavioursRequest"]),
            ...mapActions("groups", ["getGroupsByTenantRequest"]),
            onSubmit(e) {
                // e.preventDefault();
                // !this.isNew() ? this.updateUserRequest({this.user, $toasted}) : this.createUserRequest({this.user, $toaster})
            },
            async loadBehaviour() {
                if (this.currentUser == undefined) {
                    await this.fetchCurrentUser();
                }

                if (this.currentUser != undefined) {
                    const selectedCountryId = this.currentUser.selectedCountryId;
                    await this.getBehavioursRequest(selectedCountryId);
                    await this.getGroupsByTenantRequest(selectedCountryId);
                }

                let behaviour = this.behaviours && this.behaviours.length > 0 ? this.behaviours.find(b => b.id === this.getId()) : null


                if (behaviour != null) {
                    if(behaviour.groupId != null) {
                        this.selectedGroup = this.groups.find(x => x.id == behaviour.groupId)
                    }
                    const selectedTimezone = behaviour.global && behaviour.timezone ? behaviour.timezone : this.selectedCountry.timezone;
                    const start = moment.unix(behaviour.startDate['seconds']).tz(selectedTimezone);
                    const end = moment.unix(behaviour.endDate['seconds']).tz(selectedTimezone);
                    this.calendarData = {
                        start: new Date(start.year(), start.month(), start.date()),
                        end: new Date(end.year(), end.month(), end.date()),
                    };
                    this.global = behaviour.global

                    // this.startDate = moment.unix(behaviour.startDate['seconds']).format('DD/MM/YYYY')
                    // this.endDate = moment.unix(behaviour.endDate['seconds']).format('DD/MM/YYYY')
                }
            },
            async saveOverlapingBehaviour() {
                const selectedTimezone = this.behaviour.global ? this.behaviour.timezone : this.selectedCountry.timezone;
                const startDate = moment(this.calendarData.start, 'DD/MM/YYYY').tz(selectedTimezone, true);
                const endDate = moment(this.calendarData.end, 'DD/MM/YYYY').tz(selectedTimezone, true);
                if (this.errorsList.length == 0) {
                    let finalEndDate = endDate.set({hour: 23, minute: 59, second: 59}).toDate()
                    if (this.isNew) {
                        let x = this.selectedGroup != null ? this.selectedGroup.id: null;
                        await this.createBehaviourRequest({
                            behaviour: {
                                groupId: x,
                                title: this.behaviour.title,
                                maxNoOfStars: this.behaviour.maxNoOfStars ? parseInt(this.behaviour.maxNoOfStars) : null,
                                maxNoOfComments: this.behaviour.maxNoOfComments ? parseInt(this.behaviour.maxNoOfComments) : null,
                                description: this.behaviour.description,
                                public: this.behaviour.public ? this.behaviour.public : false,
                                global: this.behaviour.global ? this.behaviour.global : false,
                                startDate: startDate.toDate(),
                                endDate: finalEndDate,
                                tenantId: this.behaviour.global ? null : this.selectedCountry.id,
                                timezone: this.behaviour.timezone ? this.behaviour.timezone : null,
                            },
                            $toasted: this.$toasted
                        })
                        this.calendarData = {};
                    } else {
                        let x = this.selectedGroup != null ? this.selectedGroup.id: null;
                        await this.updateBehaviourRequest({
                            id: this.behaviour.id,
                            behaviour: {
                                groupId: x,
                                title: this.behaviour.title,
                                maxNoOfStars: this.behaviour.maxNoOfStars ? parseInt(this.behaviour.maxNoOfStars) : null,
                                maxNoOfComments: this.behaviour.maxNoOfComments ? parseInt(this.behaviour.maxNoOfComments) : null,
                                description: this.behaviour.description,
                                public: this.behaviour.public ? this.behaviour.public : false,
                                global: this.behaviour.global ? this.behaviour.global : false,
                                startDate: moment(startDate, 'DD/MM/YYYY').toDate(),
                                endDate: finalEndDate,
                                tenantId: this.behaviour.global ? null : this.selectedCountry.id,
                                timezone: this.behaviour.timezone ? this.behaviour.timezone : null
                            },
                            $toasted: this.$toasted
                        })
                    }
                    this.isOverlaping = false;
                }
            },
            async saveBehaviour() {
                let behaviour = this.behaviour;
                this.errorsList = [];

                if (behaviour.title == null || behaviour.title == '') {
                    this.errorsList.push('Title is required!');
                }
                if (behaviour.description == null || behaviour.description == '') {
                    this.errorsList.push('Description is required!');
                }
                if (behaviour.maxNoOfStars != null && parseInt(behaviour.maxNoOfStars) < 0) {
                    this.errorsList.push('The maximum number of stars must be positive!');
                }
                if (behaviour.maxNoOfComments != null && parseInt(behaviour.maxNoOfComments) < 0) {
                    this.errorsList.push('The maximum number of comments must be positive!');
                }
                if (behaviour.timezone == null && behaviour.global) {
                    this.errorsList.push('Timezone is required!');
                }

                const selectedTimezone = this.behaviour.global ? this.behaviour.timezone : this.selectedCountry.timezone;
                let startDate = moment(this.calendarData.start, 'DD/MM/YYYY').tz(selectedTimezone, true);
                const endDate = moment(this.calendarData.end, 'DD/MM/YYYY').tz(selectedTimezone, true);
                if (startDate == null) {
                    this.errorsList.push('Start date is required!');
                }
                if (endDate == null) {
                    this.errorsList.push('End date is required!');
                }

                const overlapingBehaviours = this.behaviours.filter(behaviour =>
                    startDate.isBetween(moment.unix(behaviour.startDate['seconds']), moment.unix(behaviour.endDate['seconds']))
                    || endDate.isBetween(moment.unix(behaviour.startDate['seconds']), moment.unix(behaviour.endDate['seconds']))
                    || moment.unix(behaviour.startDate['seconds']).isBetween(startDate, endDate)
                    || moment.unix(behaviour.endDate['seconds']).isBetween(startDate, endDate))

                this.isOverlaping = false;
                if (overlapingBehaviours.length > 0) {
                    if (!(!this.isNew && overlapingBehaviours.length == 1 && overlapingBehaviours[0].id == this.behaviour.id))
                    // this.errorsList.push('There is another configured behaviour in this date interval!');
                        this.isOverlaping = true;
                }
                if (this.errorsList.length == 0 && !this.isOverlaping) {
                    let finalEndDate = endDate.set({hour: 23, minute: 59, second: 59}).toDate()
                    let x = this.selectedGroup != null ? this.selectedGroup.id: null;
                    if (this.isNew) {
                        await this.createBehaviourRequest({
                            behaviour: {
                                groupId: x,
                                title: this.behaviour.title,
                                maxNoOfStars: this.behaviour.maxNoOfStars ? parseInt(this.behaviour.maxNoOfStars) : null,
                                maxNoOfComments: this.behaviour.maxNoOfComments ? parseInt(this.behaviour.maxNoOfComments) : null,
                                description: this.behaviour.description,
                                public: this.behaviour.public ? this.behaviour.public : false,
                                global: this.behaviour.global ? this.behaviour.global : false,
                                startDate: startDate.toDate(),
                                endDate: finalEndDate,
                                tenantId: this.behaviour.global ? null : this.selectedCountry.id,
                                timezone: this.behaviour.timezone ? this.behaviour.timezone : null
                            },
                            $toasted: this.$toasted
                        })
                        this.calendarData = {};
                    } else {
                        await this.updateBehaviourRequest({
                            id: this.behaviour.id,
                            behaviour: {
                                groupId: x,
                                title: this.behaviour.title,
                                maxNoOfStars: this.behaviour.maxNoOfStars ? parseInt(this.behaviour.maxNoOfStars) : null,
                                maxNoOfComments: this.behaviour.maxNoOfComments ? parseInt(this.behaviour.maxNoOfComments) : null,
                                description: this.behaviour.description,
                                public: this.behaviour.public ? this.behaviour.public : false,
                                global: this.behaviour.global ? this.behaviour.global : false,
                                startDate: moment(startDate, 'DD/MM/YYYY').toDate(),
                                endDate: finalEndDate,
                                tenantId: this.behaviour.global ? null : this.selectedCountry.id,
                                timezone: this.behaviour.timezone ? this.behaviour.timezone : null
                            },
                            $toasted: this.$toasted
                        })
                    }
                }
            },
            goBack() {
                this.$router.replace('/app/content/behaviours');
            },
            findBehaviour(id) {
                let behaviour = this.behaviours && this.behaviours.length > 0 ? this.behaviours.find(b => b.id === id) : null
                if (behaviour != null) {
                    this.global = behaviour.global
                    // this.startDate = moment.unix(behaviour.startDate['seconds']).format('DD/MM/YYYY')
                    // this.endDate = moment.unix(behaviour.endDate['seconds']).format('DD/MM/YYYY')
                }
                return behaviour;
            },
            getId() {
                return this.$route.params.id || -1;
            },
            selectDate(val, key) {
                Vue.set(this, key, val);
            },
            updateBehaviourProperty(value, key) {
                let behaviour = this.behaviour;

                behaviour[key] = value.target.value;

                // if(!this.isNew)
                //  this.updateBehaviour(behaviour);
            },
            togglePublic() {
                let behaviour = this.behaviour;
                behaviour.public = (behaviour.public == null || behaviour.public == false) ? true : false
            },
            toggleGlobal() {
                let behaviour = this.behaviour;
                behaviour.global = (behaviour.global == null || behaviour.global == false) ? true : false
                this.global = behaviour.global;
                if(this.global)
                    this.selectedGroup = null;
                this.behaviour.timezone = null;
            },
            showGlobalOption() {
                if (this.currentUser) {
                    const userAuthorities = this.currentUser.userAuthorities;
                    const rootAuthority = userAuthorities.filter(a => a.role == 'ROLE_ROOT')
                    if (rootAuthority.length > 0 && this.selectedGroup == null) {
                        return true;
                    }
                }
                return false;
            },
            getTimezoneOptions() {
                return moment.tz.names();
            }
        }
    }
</script>

<style scoped>

</style>
